var nurseslounge_lounge = {
    overview:function($params){
        nurseslounge_myDashboard_recommendations.init($params);
        nurseslounge_myDashboard_accountSettings.init($params);
        nurseslounge_lounge_header.init($params, 'nurseslounge_lounge', 'overview');
        nurseslounge_lounge.submenu($params, function(){
            $(".nav-underline a[data-id='overview']").click();
        });
    },
    overview_sub:function($params){
        nurseslounge_lounge_overview.init($params);
    },
    activity:function($params){
        nurseslounge_myDashboard_recommendations.init($params);
        nurseslounge_myDashboard_accountSettings.init($params);
        nurseslounge_lounge_header.init($params, 'nurseslounge_lounge', 'activity');
        nurseslounge_lounge.submenu($params, function(){
            $(".nav-underline a[data-id='activity']").click();
        });
    },
    activity_sub:function($params){
        nurseslounge_lounge_activity.init($params);
    },
    nursingJobs:function($params){
        nurseslounge_myDashboard_recommendations.init($params);
        nurseslounge_myDashboard_accountSettings.init($params);
        nurseslounge_lounge_header.init($params, 'nurseslounge_lounge', 'nursingJobs');
        nurseslounge_lounge.submenu($params, function(){
            $(".nav-underline a[data-id='nursingJobs']").click();
        });
    },
    nursingJobs_sub:function($params){
        nurseslounge_lounge_nursingJobs.init($params);
    },
    nursingFacultyJobs:function($params){
        nurseslounge_myDashboard_recommendations.init($params);
        nurseslounge_myDashboard_accountSettings.init($params);
        nurseslounge_lounge_header.init($params, 'nurseslounge_lounge', 'nursingFacultyJobs');
        nurseslounge_lounge.submenu($params, function(){
            $(".nav-underline a[data-id='nursingFacultyJobs']").click();
        });
    },
    nursingFacultyJobs_sub:function($params){
        nurseslounge_lounge_nursingJobs.init($params);
    },
    ratingReviews:function($params){
        nurseslounge_myDashboard_recommendations.init($params);
        nurseslounge_myDashboard_accountSettings.init($params);
        nurseslounge_lounge_header.init($params, 'nurseslounge_lounge', 'ratingReviews');
        nurseslounge_lounge.submenu($params, function(){
            $(".nav-underline a[data-id='ratingReviews']").click();
        });
    },
    ratingReviews_sub:function($params){
        nurseslounge_lounge_ratingReviews.init($params);
    },
    calendar:function($params){
        nurseslounge_myDashboard_recommendations.init($params);
        nurseslounge_myDashboard_accountSettings.init($params);
        nurseslounge_lounge_header.init($params, 'nurseslounge_lounge', 'calendar');
        nurseslounge_lounge.submenu($params, function(){
            $(".nav-underline a[data-id='calendar']").click();
        });
    },
    calendar_sub:function($params){
        nurseslounge_lounge_calendar.init($params);
    },
    followers:function($params){
        nurseslounge_myDashboard_recommendations.init($params);
        nurseslounge_myDashboard_accountSettings.init($params);
        nurseslounge_lounge_header.init($params, 'nurseslounge_lounge', 'followers');
        nurseslounge_lounge.submenu($params, function(){
            $(".nav-underline a[data-id='followers']").click();
        });
    },
    followers_sub:function($params){
        nurseslounge_lounge_followers.init($params);
    },
    degrees:function($params){
        nurseslounge_myDashboard_recommendations.init($params);
        nurseslounge_myDashboard_accountSettings.init($params);
        nurseslounge_lounge_header.init($params, 'nurseslounge_lounge', 'degrees');
        nurseslounge_lounge.submenu($params, function(){
            $(".nav-underline a[data-id='degrees']").click();
        });
    },
    degrees_sub:function($params){
        nurseslounge_lounge_degrees.init($params);
    },
    submenu:function($params, cback){
        $(".nav-underline a").unbind().click(function(){
            $(".nav-underline a").removeClass('active');
            nurseslounge_lounge.submenu_open(this, $(this).data('url'),  $(this).data('id')+'_sub', $params);
        });
        nurseslounge_lounge.menu_selector();
        var $notification = nurseslounge_lounge.notification_open($params, window.location.href.toString());
        if($notification.valid){
            var $open = '';
            switch($params.notification_type){
                case  'loungeWall':{$open = 'activity';break;}
                case  'loungeFollowers':{$open = 'followers';break;}
                case  'loungeReviews':{$open = 'ratingReviews';break;}
                //case  'degreeReviews':{$open = 'reviews';break;}
            }
            $(".nav-underline a").each(function(){
                var $that = $(this);
                if($that.data('id') == $open){
                    $that.addClass('active')
                }
            });
            $params = $.extend({}, $params, {user_id:libs.memoryGet('user_id')});
            libs.subrender($notification.url, 'nurseslounge_lounge', $notification.module+'_sub', $params, 'POST');
        }else{
            cback();
        }
    },
    submenu_open:function($this, $url, $module, $params){
        $params = $.extend({}, $params, {
            user_id:libs.memoryGet('user_id'),
            notification_key:null,
            notification_type:null,
            notification_type_key:null,
        });
        $($this).addClass('active');
        router.pause();
        router.navigate($url);
        router.resume();
        libs.subrender($url, 'nurseslounge_lounge', $module, $params, 'POST');
    },
    notification_open:function($params, $location){
        var $notification = {};
        var $notificationData = [];
        if($params.notification_key){$notificationData.push($params.notification_key);}
        if($params.notification_type){$notificationData.push($params.notification_type);}
        if($params.notification_type_key){$notificationData.push($params.notification_type_key);}
        $notification.valid = $notificationData.length == 3;
        $notification.url = $location.replace('/notification/'+$notificationData.join('/'), '');
        var $url = $notification.url.split('/');
        $notification.module = $url[$url.length-1];
        return $notification;
    },
    menu_selector:function(){
        libs.globalUrl();
    }
};
